var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _clipPath, _clipPath2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVault3D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7faef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c8df1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 0.429235,
    x2: 1.529,
    xlinkHref: "#a",
    y1: 8.29362,
    y2: 8.29362
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 0.429235,
    x2: 1.529,
    xlinkHref: "#a",
    y1: 21.7062,
    y2: 21.7062
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 7.62406,
    x2: 27.8167,
    xlinkHref: "#a",
    y1: 6.79862,
    y2: 26.9912
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c8df1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5631,
    stopColor: "#466cc8",
    stopOpacity: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4256ac"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 22.3148,
    x2: 14.3677,
    xlinkHref: "#e",
    y1: 21.4892,
    y2: 13.5421
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4447,
    x2: 13.025,
    xlinkHref: "#e",
    y1: 16.6192,
    y2: 12.1995
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbd0e4"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 8.65793,
    x2: 10.0359,
    xlinkHref: "#h",
    y1: 20.8844,
    y2: 22.2623
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7101,
    x2: 23.088,
    xlinkHref: "#h",
    y1: 7.83219,
    y2: 9.21019
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 9.75781,
    x2: 8.15852,
    xlinkHref: "#h",
    y1: 8.01554,
    y2: 9.6149
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 22.81,
    x2: 21.2107,
    xlinkHref: "#h",
    y1: 21.0677,
    y2: 22.667
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 13.068,
    x2: 18.7525,
    y1: 12.2423,
    y2: 17.9269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebeff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3e5e4"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 17.9783,
    x2: 13.5407,
    xlinkHref: "#h",
    y1: 17.1526,
    y2: 12.715
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 15.8255,
    x2: 15.8255,
    y1: 26.8275,
    y2: 30.8794
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4256ac",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1464"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 29.3092,
    x2: 26.3307,
    xlinkHref: "#e",
    y1: 16.994,
    y2: 16.322
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 26.6092,
    x2: 27.5738,
    xlinkHref: "#h",
    y1: 15.0001,
    y2: 15.0001
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30v30h-30z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30v30h-30z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.30235 12.0296h-2.382703c-.507882 0-.919647-.4118-.919647-.9197v-5.63258c0-.50794.411765-.9197.919647-.9197h2.382703z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.30235 25.4422h-2.382703c-.507882 0-.919647-.4118-.919647-.9197v-5.6326c0-.508.411765-.9197.919647-.9197h2.382703z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.3221 29.1745h-22.99309c-1.47895 0-2.67789-1.1989-2.67789-2.6779v-22.99303c0-1.47895 1.19894-2.677886 2.67789-2.677886h22.99309c1.4789 0 2.6778 1.198936 2.6778 2.677886v22.99303c0 1.479-1.1989 2.6779-2.6778 2.6779z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 26.4965v-15.4455l-5.0968-5.12876c-.5511-.55047-1.3221-.4283-1.8732.12217l-3.0488 3.04877c-1.1857-.80265-2.6159-1.39371-4.1557-1.39371-4.0996 0-7.30038 3.20083-7.30038 7.30043 0 1.5398.52994 3.031 1.33258 4.2168l-3.04876 2.9877c-.55047.5511-.61159 1.3221-.06112 1.8733l5.12528 5.0967h15.4491c1.4789 0 2.6778-1.1989 2.6778-2.6779z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.8256 19.0974c2.2628 0 4.0973-1.8344 4.0973-4.0973 0-2.2628-1.8345-4.0973-4.0973-4.0973-2.2629 0-4.0973 1.8345-4.0973 4.0973 0 2.2629 1.8344 4.0973 4.0973 4.0973z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8489 19.972-4.10567 4.1057c-.55112.5505-1.44436.5505-1.99542 0-.55047-.5511-.55047-1.4444 0-1.9954l4.10569-4.1057c.4906.8181 1.1774 1.5048 1.9954 1.9954z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3164 6.91984c0 .36105-.1381.72217-.413.9977l-4.1057 4.10566c-.4906-.818-1.1774-1.5048-1.9955-1.9954l4.1058-4.10567c.5511-.55047 1.4443-.55047 1.9954 0 .2749.27559.413.63665.413.99771z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.74323 5.92213 4.10567 4.10567c-.818.4906-1.5048 1.1774-1.9954 1.9954l-4.10569-4.10566c-.55047-.55112-.55047-1.44435 0-1.99541.55112-.55047 1.44436-.55047 1.99542 0z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9034 24.0777c-.2756.2749-.6367.413-.9977.413-.3611 0-.7222-.1381-.9977-.413l-4.1058-4.1057c.8181-.4906 1.5049-1.1774 1.9955-1.9954l4.1057 4.1057c.5504.5511.5504 1.4443 0 1.9954z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.8255 7.57715c-4.0996 0-7.42267 3.32305-7.42267 7.42265s3.32307 7.4226 7.42267 7.4226 7.4226-3.323 7.4226-7.4226-3.323-7.42265-7.4226-7.42265zm0 11.08965c-2.0254 0-3.667-1.6417-3.667-3.667 0-2.0254 1.6416-3.667 3.667-3.667 2.0253 0 3.667 1.6416 3.667 3.667 0 2.0253-1.6417 3.667-3.667 3.667z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.8257 20.7944c3.2002 0 5.7944-2.5942 5.7944-5.7944 0-3.2003-2.5942-5.79443-5.7944-5.79443-3.2003 0-5.7945 2.59413-5.7945 5.79443 0 3.2002 2.5942 5.7944 5.7945 5.7944zm0-9.4615c2.0253 0 3.667 1.6417 3.667 3.667 0 2.0254-1.6417 3.667-3.667 3.667-2.0254 0-3.667-1.6416-3.667-3.667 0-2.0253 1.6416-3.667 3.667-3.667z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.65112 23.9888v2.5078c0 1.4789 1.19894 2.6779 2.67789 2.6779h22.99309c1.4789 0 2.6778-1.199 2.6778-2.6779v-2.5078z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.0001 13.7106-2.4158-2.4158c-.167-.1975-.4162-.3231-.6951-.3231-.5029 0-.9104.4076-.9104.9105v6.3735c0 .2789.1257.5282.3231.6952l3.6982 3.6983z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.8204 19.0974c-.5028 0-.9105-.4077-.9105-.9105v-6.3736c0-.5029.4077-.9105.9105-.9105.5029 0 .9105.4077.9105.9105v6.3736c0 .5028-.4076.9105-.9105.9105z",
    fill: "url(#q)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault3D);
export default __webpack_public_path__ + "static/media/vault_3d.42edf66e0c767dbf2f4707bfb5605449.svg";
export { ForwardRef as ReactComponent };